module.exports = __webpack_public_path__ + "icomoon.9d2f8752.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/fonts/icomoon/icomoon.ttf
// module id = 1323
// module chunks = 1